//import { Defaults } from "@/models/Defaults";
import { User } from "@/models/User";
import instanceAxios from "./axiosInst";
import { useUserStore } from "@/stores/root/users";

export class UserData {
  static production = process.env.NODE_ENV === "development" ? false : true;
  /**
   * Login user.
   * @param email
   * @param password
   */
  static async login(
    email: string,
    password: string
  ): Promise<{ error: boolean; message: string; result: any }> {
    const result = {
      error: false,
      message: "",
      result: "{}",
    };
    let response;
    try {
      response = await this.getToken(email, password);
    } catch (error: any) {
      result.error = true;
      result.message = error.response?.data?.message;
    }

    try {
      //get user data
      const { data } = await instanceAxios.get(
        process.env.VUE_APP_MAGENTO_URL + "/rest/V1/customers/me"
      );

      //Create new login in vuex
      this.storeUserFromData(data, true);
    } catch (error) {
      result.error = true;
      if (result.message === "") result.message = "Unknown error";
    }
    result.result = response?.data;
    return result;
    // return new Promise<{ error: boolean; message: string; result: any }>(
    //   resolve => {
    //     resolve(result);
    //   }
    // );
  }
  //this in <boolean> instead of {}
  static async logout(): Promise<{ error: boolean; message: string }> {
    const userStore = useUserStore();
    const result = {
      error: false,
      message: "",
    };
    localStorage.removeItem("token");
    //userStore.user = new User();
    userStore.logout;

    return new Promise<{ error: boolean; message: string }>((resolve) => {
      resolve(result);
    });
  }

  /**
   * Create new user.
   * @param email
   * @param password
   * @param firstName
   * @param lastName
   * @param instanceAxios
   */
  static async createUser(
    email: string,
    password: string,
    firstName: string,
    lastName: string
  ): Promise<{ error: boolean; message: string }> {
    const result = {
      error: false,
      message: "",
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    //let response;
    try {
      const { data } = await instanceAxios.post(
        process.env.VUE_APP_MAGENTO_URL + "/rest/V1/customers",
        {
          customer: {
            email: email,
            firstname: firstName,
            lastname: lastName,
            store_id: 1,
          },
          password: password,
        }
      );
      //create user in WISE
      const wiseBody = {
        entityId: data.id,
        firstName: firstName,
        lastName: lastName,
        email: email,
      };
      try {
        await this.getToken(email, password);
      } catch (error) {
        result.error = true;
        result.message = "Unknown error";
      }
      await instanceAxios.post(
        process.env.VUE_APP_MAGENTO_URL + "/rest/V1/WAG/wise/create/customer",
        wiseBody
      );
    } catch (error: any) {
      result.error = true;
      if (error.response?.data?.message) {
        result.message = error.response.data.message;
      } else {
        result.message = "Unknown error";
      }
    }
    // if (response && response.data.code != 0) {
    //   result.error = true;
    //   result.message = response.data.msg;
    // }

    return result;

    // return new Promise<{ error: boolean; message: string }>(resolve => {
    //   resolve(result);
    // });
  }

  /**
   * Checks if a user is logged in
   * @returns
   */
  static async fetchUser(): Promise<{
    error: boolean;
    message: string;
    result: { user: any; loggedIn: boolean };
  }> {
    const result = {
      error: false,
      message: "",
      result: { user: {}, loggedIn: false },
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let response;
    try {
      response = await instanceAxios.get(
        process.env.VUE_APP_MAGENTO_URL + "/rest/V1/customers/me"
      );
    } catch (error) {
      result.error = true;
      result.message = "Unknown error";
    }
    if (!result.error) {
      const status = response?.status;
      const data = response?.data;
      switch (status) {
        case 200: {
          if (data.code == 5) {
            //if (UserData.production) {
            result.result.loggedIn = false;
          }
          // } else if (data.code !== 0) {
          //   result.error = true;
          //   result.message = data.msg;
          //  }
          else {
            result.error = false;
            result.message = "";
            // if (User.production) {
            result.result.user = data.model;
            result.result.loggedIn = true;
            // }
          }
          break;
        }
        default: {
          result.error = true;
          result.message = "Unknown error";
        }
      }
    }

    return new Promise<{
      error: boolean;
      message: string;
      result: { user: any; loggedIn: boolean };
    }>((resolve) => {
      resolve(result);
    });
  }
  /**
   * Creates local user from the data returned from the remote system, and persists it to vuex store.
   * @param data
   */
  private static storeUserFromData(data: any, loggedIn = true) {
    const userStore = useUserStore();
    const user = new User();
    user.entityId = data.id;
    user.firstName = data.firstname;
    user.lastName = data.lastname;
    user.loggedIn = loggedIn;
    user.email = data.email;

    //store.dispatch("Root/login", user);
    //window.location.href = "/login";
    userStore.user = user;
  }
  private static async getToken(email: any, password: any) {
    // Get the Magento token first and import into local storage
    const response = await instanceAxios.post(
      process.env.VUE_APP_MAGENTO_URL + "/rest/V1/integration/customer/token",
      {
        username: email,
        password: password,
      }
    );
    localStorage.setItem("token", response.data);
    return response;
  }
}
